module.exports = __webpack_public_path__ + "img/bg.2f3027fa.jpeg";